<template>
  <SKAlert :mode="mode">
    <div>{{ description }}</div>
  </SKAlert>
</template>

<script>
import { SKAlert } from "sentiance.commons.sentikit";
export default {
  name: "Highlights",
  components: { SKAlert },
  props: {
    description: {
      type: String,
    },
    mode: {
      type: String,
    },
  },
};
</script>
